function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportationAirplane2Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.623 18.333h2.86c1.863 0 6.517 0 6.517-2.333s-4.655-2.333-6.517-2.334h-2.86L12.868 2.782a1.86 1.86 0 00-1.515-.781L10.669 2a.934.934 0 00-.91 1.13l2.252 10.537H8.307l-1.971-3.294a1.864 1.864 0 00-1.597-.907h-.603a.934.934 0 00-.914 1.117l.71 3.55h.2C3.45 14.558 3.003 15.233 3 16c0 .767.45 1.442 1.133 1.866h-.201l-.71 3.55a.933.933 0 00.914 1.117h.603c.654 0 1.26-.344 1.597-.907l1.971-3.293h3.704L9.76 28.871a.932.932 0 00.91 1.128l.684.001a1.86 1.86 0 001.514-.782l7.756-10.885z",
    fill: props.color
  }));
}

export default SvgIconTransportationAirplane2Filled;